/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import YearFilterCard from '../../../../common/components/YearFilterCard/YearFilterCard';
import LeaveAppliedContent from '../../../../common/components/LeaveAppliedContent/LeaveAppliedContent';
import _ from 'lodash';
import { getPreviousYears } from '../../../../common/configs/utils';
interface propsType {
  leaveData: any;
  setFilterYear: (data: number) => void;
  isLoading?: boolean;
  trans?: any;
  setTypeFilter: (data: string) => void;
}

import moment from 'moment';
import LeaveHistoryViewModalController from '../../../../common/Modals/Leaves/LeaveHistoryViewModal/LeaveHistoryViewModalController';
import Loader from '../../../../common/Lottifiers/Loader/Loader';
import { useTranslate } from '../../../../hooks';
import { baseDateFormatting } from '../../../../common/helper';
import LeaveRejoinform from './LeaveRejoinform';
import { leavesService } from '../../../../api/services/leavesService';
import LeaveRejointargetDetails from './LeaveRejointargetDetails';

const EmergencyContactPresenter: React.FC<propsType> = ({
  leaveData,
  setFilterYear,
  isLoading,
  trans,
  setTypeFilter,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [openRejoinModal, setOpenRejoinModal] = useState(false);
  const [openRejoinDetailsModal, setOpenRejoinDetailsModal] = useState(false);
  const [yearTitle, setyearTitle] = useState(moment(new Date()).format('YYYY'));
  const [leaveType, setleaveType] = useState('Leaves');
  const [leaveHistoryViewData, setLeaveHistoryViewData] = useState({});
  const [rejoinexistdata, setRejoinexistdata] = useState({});

  const { translate } = useTranslate();

  const handleSelectyear = (year: any) => {
    setyearTitle(year.label);
    setFilterYear(year.id);
  };
  const handleSelecttype = (type: any) => {
    setleaveType(type?.id);
    setTypeFilter(type?.id);
  };
  const getData = (data: any) => {
    console.log('data from modal', data);
  };
  const handleRejoinFormDetails = async (leaveData: any) => {
    await leavesService
      .getRejoinFormDetails(leaveData?.id)
      .then((response: any) => {
        const rejoinData = response?.data;
        if (rejoinData) {
          setOpenRejoinDetailsModal(true);
          setRejoinexistdata(rejoinData);
        } else {
          setOpenRejoinModal(true);
        }

        //console.log('response from rejoin form details', response);
      });
  };
  return (
    <>
      <YearFilterCard
        card_height="650px"
        height="650px"
        card_title={trans('Leave History')}
        onYearSelect={handleSelectyear}
        yearMenu={getPreviousYears()}
        yearTitle={yearTitle}
        filterhead={[
          { id: 'Leaves', label: translate('Leaves'), color: '#7C0E6F' },
          {
            id: 'Leave Advance',
            label: translate('Leave Advance'),
            color: '#7C0E6F',
          },
          {
            id: 'Leave Encashment',
            label: translate('Leave Encashment'),
            color: '#7C0E6F',
          },
        ]}
        onfilterhead={handleSelecttype}
        leaveType={translate(leaveType) ?? ''}
      >
        {isLoading ? (
          <Loader height={100} width={200} />
        ) : (
          <>
            {_.map(leaveData, (leave) => {
              return (
                <LeaveAppliedContent
                  leaveName={translate(leave?.leave_type?.name)}
                  endDate={moment(leave?.end_date).format(baseDateFormatting)}
                  startDate={moment(leave?.start_date).format(
                    baseDateFormatting,
                  )}
                  totalLeaveDays={leave?.total_leave_days}
                  status={leave?.status}
                  encashtype={leave?.encashment_type}
                  payment_type={leave?.payment_type}
                  amount={leave?.amount}
                  onClick={() => {
                    setOpenModal(true);
                    setLeaveHistoryViewData(leave);
                  }}
                  onRejoinForm={() => {
                    handleRejoinFormDetails(leave);

                    setLeaveHistoryViewData(leave);
                  }}
                />
              );
            })}
          </>
        )}
      </YearFilterCard>

      {/* View Leave History Modal */}

      {openModal && (
        <LeaveHistoryViewModalController
          isModalOpen={openModal}
          closeModal={() => setOpenModal(false)}
          leaveHistoryViewData={leaveHistoryViewData}
          trans={trans}
        />
      )}
      {openRejoinDetailsModal && (
        <LeaveRejointargetDetails
          isModalOpen={openRejoinDetailsModal}
          closeModal={() => setOpenRejoinDetailsModal(false)}
          rejoinexistdata={rejoinexistdata}
          trans={trans}
        />
      )}
      {openRejoinModal && (
        <LeaveRejoinform
          isModalOpen={openRejoinModal}
          closeModal={() => setOpenRejoinModal(false)}
          leaveHistoryViewData={leaveHistoryViewData}
          trans={trans}
          callBackGetData={getData} // Provide the appropriate callback function here
          leaveEligibility={null} // Provide the appropriate eligibility data here
        />
      )}
    </>
  );
};

export default EmergencyContactPresenter;
